var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckCircleRegular = function SvgCheckCircleRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C22.386 0 0 22.386 0 50s22.386 50 50 50 50-22.386 50-50S77.614 0 50 0zm0 9.677c22.285 0 40.323 18.035 40.323 40.323 0 22.285-18.035 40.323-40.323 40.323C27.715 90.323 9.677 72.288 9.677 50 9.677 27.715 27.712 9.677 50 9.677m28.267 26.264-4.544-4.58a2.42 2.42 0 0 0-3.421-.014l-28.498 28.27-12.055-12.153a2.42 2.42 0 0 0-3.422-.014l-4.58 4.543a2.42 2.42 0 0 0-.014 3.422l18.303 18.45a2.42 2.42 0 0 0 3.421.014l34.796-34.517a2.42 2.42 0 0 0 .014-3.421z",
    fill: "#4FD13D"
  })));
};

export default SvgCheckCircleRegular;